import React from "react";

const ArrowIcon = ({ color = "#fff", ...props }) => {
  return (
    <svg
      width="44"
      height="42"
      viewBox="0 0 44 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.6504 41.25L-0.00023672 7.36576e-06L43.301 1.11513e-05L21.6504 41.25Z"
        fill="white"
      />
    </svg>
  );
};

export default ArrowIcon;
